module.exports = __webpack_public_path__ + "static/ogrodzenia-1-333bb8885507a35ae851ce4fcf984948.jpg";